/**
 * External dependencies
 */
export default class CubeJs {
  constructor(cscom) {
    if (!(this instanceof CubeJs)) {
      return new CubeJs(cscom);
    }
    this.cscom = cscom;
  }

  getToken() {
    return this.cscom.req.get("/api/rest/talink/dashboard/cube-js/token");
  }

  triggerPreAggregations() {
    return this.cscom.req.post(
      "/api/rest/talink/dashboard/cube-js/trigger-pre-aggregations"
    );
  }
}
